<template>
    <div v-if="this.$store.state.isLoggedIn" class="pay-info-container">
      <div class="input-title">결제 방법</div>
        <div class="option-border"></div>
        <div class="pay-info-title">입금 계좌<br>
            토스뱅크 1001-7620-3024 (송*예)</div>
        <input class="info-input" v-model="this.accountName" type="text" placeholder="입금자명" required>
        <div class="icon-container">
        <div class="icon" @mouseover="showInfo" @mouseleave="hideInfo">
          <img src="@/assets/service/question.png" width="20" class="item-img">
        </div>
        <div v-if="isInfoVisible" class="info-box">
          카드 결제와 관련된 문의는 입금자명에 본인 성함 작성하여 '결제하기' 버튼 클릭 후 문의 채널로 문의 주세요!
        </div>
      </div>
        
    </div>
    <div><button class="pay-btn" @click="goPayment">결제하기</button></div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { updateDoc, getDoc, doc, getFirestore } from 'firebase/firestore';
import { showAlert } from '@/plugins/dialog'
import { requireLogin } from '@/plugins/auth-modal'
export default {
    data(){
      return{
        accountName : '',
      }
    },

    methods:{

        async goPayment(){
            const obj = store.state.surveyOption
            if(obj.title == '' || obj.institute == '' || obj.link == ''){
              await showAlert("필수 항목을 모두 입력해주세요.")
              return
            }

            if(this.$store.state.isLoggedIn){
              this.fbService()
              return
            }

            const loggedIn = await requireLogin()
            if (loggedIn) {
              this.fbService()
            }
        },

        async fbService(){
          const obj = store.state.surveyOption
          store.commit('saveAccountName', {
                    accountName: this.accountName
                })
                const pointAdd = Math.floor((obj.price - (obj.point + obj.coupon))*0.03)
                try {
                    await axios.post(
                        'https://gosurveasy.co.kr/survey',
                        {
                            headCount: obj.headCount,
                            spendTime: obj.spendTime,
                            dueDate: new Date(store.state.surveyOption.endDate + "T" + store.state.surveyOption.endTime + "Z"),
                            targetGender: obj.targetGender,
                            targetAgeList: obj.targetAge,
                            language: obj.language,
                            identity: obj.identity,
                            title: obj.title,
                            targetInput: obj.targetInput,
                            institute: obj.institute,
                            link: obj.link,
                            description: obj.description,
                            notice: obj.notice,
                            accountName: obj.accountName,
                            price: obj.price - (obj.point + obj.coupon),
                            priceDiscounted: obj.priceDiscounted,
                            pointAdd: pointAdd,
                            email: this.$store.state.currentUser.email,
                            username: this.$store.state.currentUser.name
                        }
                    )
                    this.$router.push("/service/payfdone")

                    const db = getFirestore()
                    const userEmail = this.$store.state.currentUser.email
                    const docSnap = await getDoc(doc(db, "userData", userEmail.toString()))
                    console.log(pointAdd)
                    console.log('pointAdd')

                    const botId = "5505316703:AAGLByXDGZ0pE4n4-sAtU1SZW8GNgMs6dtE";
                    // const chatId = "5620110827";
                    const chatIds = ["5620110827", "5792894818", "5551257956"]
                    const dueDateString = store.state.surveyOption.endDate + " " +store.state.surveyOption.endTime;
                    for (let i = 0; i < chatIds.length; i++) {
                                        try {
                        await axios.post(
                            `https://api.telegram.org/bot${botId}/sendMessage`,
                            {
                                chat_id: chatIds[i],
                                text: 
                                ` 설문 등록됨
제목 : ${obj.title},
마감기한 : ${dueDateString},
요구인원 : ${obj.headCount},
소요시간 : ${obj.spendTime},
타겟성별 : ${obj.targetGender},
링크 : ${obj.link},
                                `
                            }
                        
                        )
                    } catch (error) {
                    console.log(error)
                    console.log('에러났음')
                    }
                    }



                    if(docSnap.exists()){
                        const data = docSnap.data()
                        const now = data.point_current
                        const total = data.point_total
                        const docref = doc(db, "userData", userEmail.toString())
                        await updateDoc(docref, { 
                            point_current: (now - obj.point) + pointAdd,
                            point_total: total + pointAdd
                        })
                    }

                } catch (error) {
                    console.log(error)
                }
            }
        

    }
}
</script>

<style scoped>
.pay-info-container {
    display: flex;
    flex-direction: column;
    font-family: var(--font-sans);
    text-align: left;
    max-width: 552px;
    margin: 24px auto 0;
    padding: 24px;
    box-sizing: border-box;
    background-color: var(--surface-card);
    border: 1px solid var(--ink-100);
    border-radius: var(--radius-xl);
    box-shadow: var(--shadow-md);
}

.input-title{
  font-size: 18px;
  font-weight: var(--font-weight-semibold);
  color: var(--ink-900);
}

.option-border{
  border-top: 1px solid var(--ink-200);
  margin-top: 14px;
}

.pay-info-container .info-input {
    box-sizing: border-box;
    margin-top: 10px;
    width: 100%;
    height: 40px;
    padding: 0 12px;
    font-family: var(--font-sans);
    font-size: 14px;
    color: var(--ink-800);
    background-color: var(--white);
    border: 1px solid var(--ink-200);
    border-radius: var(--radius-md);
}

.pay-info-container .info-input:focus {
    outline: none;
    border-color: var(--green-500);
}

.pay-info-title{
    text-align: left;
    font-size: 14px;
    color: var(--ink-800);
    font-weight: var(--font-weight-semibold);
    margin-top: 16px;
    line-height: 1.5;
}
.pay-btn {
  width: 100%;
  max-width: 552px;
  box-sizing: border-box;
  height: 48px;
  margin: 16px auto 0;
  display: block;
  color: var(--white);
  background-color: var(--green-500);
  border: 1px solid var(--green-500);
  border-radius: var(--radius-md);
  font-size: 16px;
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  font-family: var(--font-sans);
}

.pay-btn:hover {
  background: var(--green-600);
  border-color: var(--green-600);
}

.icon-container {
  position: relative;
  align-self: flex-start;
  margin-top: 8px;
}

.icon {
  cursor: pointer;
}

.info-box {
  position: absolute;
  top: 100%;
  left: 0;
  width: 260px;
  max-width: 60vw;
  background-color: var(--white);
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  padding: 10px 12px;
  display: none;
  font-family: var(--font-sans);
  font-size: 12px;
  color: var(--ink-600);
  line-height: 1.5;
}

.icon:hover + .info-box {
  display: block;
}

</style>